import React, { Component } from 'react';
import PropTypes from 'prop-types';
import createLogger from 'src/utils/logger';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import { modalWindows } from 'src/actions';
import { Mixpanel } from '../../../Mixpanel';


import './Organizer.scss';

class Organizer extends Component {
  constructor() {
    super();
    this.logger = createLogger('Organizer');
    this.state = {
      news: '',
      newsErrors: [],
      sendingRequest: false,
      error: false,
      onHintClick: () => this.props.openAddHackatonModal(),
    };
  }
  
  componentDidMount() {
    Mixpanel.track('About', {'Card' : 'Organizer'})
  }

  render() {
    return (
      <div className="modal company">
        <div>
          <h1>Я - организатор</h1>
          <p>
            Публикуй свой хакатон на сайт с помощью <a href="/add_hackathon">специальной формы</a>.
          </p>
          <p>
             Мы помогаем организаторам проводить хорошие эвенты, которые не будут унижать члены нашего комьюнити. 
             Если вам хочется услышать фидбек по мероприятию, пригласить нас в жюри, пишите на почту: alexm@russianhackers.org
          </p>
        </div>
      </div>
    );
  }
}

Organizer.propTypes = {
  closeModal: PropTypes.func.isRequired,
  openAddHackatonModal: PropTypes.func.isRequired,
}

function mapStateToProps(state) {
  return {};
}

export default withRouter(
  connect(mapStateToProps, {
    openAddHackatonModal: modalWindows.openAddHackatonModal,
  })(Organizer)
);


// WEBPACK FOOTER //
// ./src/components/Modal/About/Organizer/index.js